import styled, { css } from 'styled-components';
import { mediasQuery } from '@utils/responsive';

const Wrapper = styled.div`
  ${mediasQuery.maxMdMax} {
    margin-bottom: 153px;
  }
`;

const WrapperKebabList = styled.div`
  grid-area: wrapperKebabList;
  text-align: right;
`;

const WrapperIcon = styled.span`
  display: inline-block;
  position: relative;
  color: ${({ theme }) => theme.color.text.neutral.weak};
  font-size: ${({ theme }) => theme.font.size.m2};
`;

const KebabList = styled.ul`
  list-style: none;
  padding: ${({ theme }) => theme.spacing.km2};

  li {
    display: inline-block;
    width: 100%;
  }

  button {
    background: transparent;
    border: none;
    color: ${({ theme }) => theme.color.text.neutral.default};
    cursor: pointer;
    width: 100%;
    display: flex;
    align-items: center;
    border-radius: ${({ theme }) => theme.border.radius.medium};
    padding: ${({ theme }) => theme.spacing.km3};

    &:hover {
      background-color: ${({ theme }) => theme.color.background.neutral.weak};
    }

    fuel-icon,
    svg {
      margin-right: ${({ theme }) => theme.spacing.km2};
    }
  }
`;

const IconMenuKebab = styled.img`
  width: 16px;
  height: 16px;
  margin-right: ${({ theme }) => theme.spacing.km2};
`;

export const WrapperHeaderTab = styled.div`
  ${({ theme }) => css`
    background: ${theme.color.background.neutral.weak};
    padding: ${theme.spacing.km3} ${theme.spacing.km4} ${theme.spacing.km3};
    white-space: nowrap;
    text-transform: uppercase;
    line-height: ${theme.font.size.m3};
    border-radius: ${theme.border.radius.large};
    .grid-container.sc-fuel-grid-container-h {
      margin: ${theme.spacing.km0};
    }
  `};
`;

export { Wrapper, IconMenuKebab, WrapperIcon, KebabList, WrapperKebabList };
